import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F7F5] py-12 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-white p-8 rounded-2xl border border-[#E2E8F0]">
          <div className="flex items-center justify-center mb-8">
            <div className="w-16 h-16 bg-[#0A3D2E] rounded-full flex items-center justify-center">
              <Lock size={32} className="text-[#CDFF00]" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-center text-[#0A3D2E] mb-8 font-['Outfit']">
            Admin Login
          </h1>

          {error && (
            <div data-testid="login-error" className="mb-6 p-4 bg-red-100 text-red-800 rounded-2xl text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="mb-6">
              <label className="block text-sm font-medium text-[#0A3D2E] mb-2">Email</label>
              <input
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-[#E2E8F0] rounded-2xl focus:ring-2 focus:ring-[#CDFF00] focus:outline-none"
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-[#0A3D2E] mb-2">Password</label>
              <input
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border border-[#E2E8F0] rounded-2xl focus:ring-2 focus:ring-[#CDFF00] focus:outline-none"
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full px-6 py-3 bg-[#0A3D2E] text-white rounded-full font-semibold hover:bg-[#07291F] transition-colors focus:ring-4 focus:ring-[#CDFF00] focus:outline-none disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
